import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import PropTypes from "prop-types";
import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import formatCurrency from "../../utils/currencyFormat";
import { summariseOrder } from "../../utils/order";
import AdditionalUserMessage from "./basket-components/AdditionalUserMessage";
import OrderItemAdditonalUsers from "./basket-components/OrderItemAdditonalUsers";
import OrderItemStatic from "./basket-components/OrderItemStatic";
import OrderItemPacks from "./basket-components/OrderItemPacks";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Button from 'react-bootstrap/Button';



const Basket = (props) => {

  const [basketSubtotal, setBasketSubtotal] = useState(0);
  const getPackages = props.packages;


  useEffect(() => {
    setBasketSubtotal(formatCurrency(summariseOrder(getPackages).subtotal));
  }, [getPackages]);
  
  const packageBlock = packageItem => {
    const { removePackageFromBasket, updateBasket } = props;

    if (!packageItem.additionalusersallowed && !packageItem.canOrderMultiple) {
      return (
        <OrderItemStatic
          key={packageItem.packageID}
          removePackageFromBasket={removePackageFromBasket}
          packageItem={packageItem}
          updateBasket={updateBasket}
        />
      );
    } else if (packageItem.canOrderMultiple) {
      return (
        <OrderItemPacks
          key={packageItem.packageID}
          removePackageFromBasket={removePackageFromBasket}
          packageItem={packageItem}
          updateBasket={updateBasket}
        />
      );
    } else {
      return (
        <OrderItemAdditonalUsers
          key={packageItem.packageID}
          removePackageFromBasket={removePackageFromBasket}
          packageItem={packageItem}
          updateBasket={updateBasket}
        />
      );
    }
  };

    const { packages, brand, paperPackage } = props;

    return (
      <Offcanvas show={props.showBasket} onHide={props.handleCloseBasket} placement="end" className="offcanvas-basket">
        <div id="order-drawer" className={`order-drawer__wrap ${props.doublestruckTheme}`}>
          <Offcanvas.Header className="order-drawer__header">
          <Container fluid>
              <Row className="order-drawer__title">
                <Col xs={12}>
                  <Button onClick={props.handleCloseBasket} className="order-Offcanvas__button"><i className="fa fa-times order-Offcanvas__icon"></i>Close</Button>
                  <i className="fa fa-shopping-cart order-drawer__title icon"></i>
                  <h2>Order Review</h2>
                </Col>
              </Row>
              </Container>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Container fluid>
              <Row>
                <Col xs={12} className="order-drawer__contents-wrap">
                  <Row className="order-drawer__continue-wrap">
                    <Col xs={12} sm={7}>
                      <h4 className="order-drawer__total">
                        Subtotal: <strong>{basketSubtotal}</strong>
                      </h4>
                    </Col>
                    <Col xs={12} sm={5} className="order-drawer__continue-button">
                      {/* Continue button - replaces Continue component. Not shown when basket empty */}
                      {packages.length > 0 && (
                        <Link to={"/order-form?brand=" + brand} style={{ textDecoration: "none" }}>
                          <Button
                            className="order-drawer__checkout-btn"
                            aria-label="Checkout"
                            onClick={() => {
                              props.handleCloseBasket();
                              window.scroll(0, 0);
                            }}
                          >
                            <i className="fa fa-check"></i>
                            Continue
                          </Button>
                        </Link>
                      )}
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} className="order-drawer__selections-wrap">
                      <AdditionalUserMessage
                        packages={packages}
                        brand={brand}
                        handleOpenBasket={props.handleOpenBasket}
                        basketOpen={props.basketOpen}
                        paperPackage={paperPackage}
                      />
                      <ListGroup.Item>
                        {packages.length > 0 ? (
                          packages.map(packageItem => packageBlock(packageItem))
                        ) : (
                          <p className="order-drawer__empty-msg">
                            Your <b>Basket</b> is empty, grab some packages and come
                            back! <br /> <i />
                          </p>
                        )}
                      </ListGroup.Item> 
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </Offcanvas.Body>
          </div>
        </Offcanvas>
        
    );
  }
Basket.propTypes = {
  /** The name of the theme either testbase or Exampro */
  doublestruckTheme: PropTypes.string,
  /** Function to remove the packages from the basket */
  removePackageFromBasket: PropTypes.func,
  /** List of all the doublestruck packages for TB, EP or OT */
  packages: PropTypes.array,
  toggleBasket: PropTypes.func,
  basketStatus: PropTypes.bool,
  updateBasket: PropTypes.func
  /** update the amount of packs the package has */
};

export default Basket;
